import React, { PropsWithChildren, useRef, useState } from 'react'

import { cn } from '@/lib/utils'

interface Props extends PropsWithChildren {
  autoScrollOnMount?: boolean
  className?: string
}

const SchedulerSection: React.FC<Props> = ({
  autoScrollOnMount: _autoScrollOnMount = false,
  className,
  children,
}) => {
  const sectionRef = useRef<HTMLElement | null>(null)
  const [_hasScrolled, _setHasScrolled] = useState(false)

  // useEffect(() => {
  //   if (autoScrollOnMount && sectionRef.current && !hasScrolled) {
  //     const sectionElement = sectionRef.current

  //     const handleAnimationEnd = () => {
  //       sectionElement.scrollIntoView({ behavior: 'smooth' })

  //       setHasScrolled(true)
  //     }

  //     sectionElement.addEventListener('animationend', handleAnimationEnd)

  //     return () => {
  //       sectionElement.removeEventListener('animationend', handleAnimationEnd)
  //     }
  //   }
  // }, [autoScrollOnMount, hasScrolled, setHasScrolled])

  return (
    <section ref={sectionRef} className={cn(className, 'pop-in')}>
      {children}
    </section>
  )
}

export default SchedulerSection
